import * as React from 'react';
import { Layer } from 'react-map-gl';

import { ILoaderProps } from '../../layer/ILoaderProps';
import { LoadableSource } from '../../layer/LoadableSource';
import { Config } from '../../../Config';

const HydrodynamicCentral = (props: ILoaderProps) => 
  <LoadableSource path="https://apigeostore.longline.co.uk/dataset/11a56f97e66072b58d091dee6e92abb7900842b6" {...props}>
    <Layer
      id='hydrodynamic_central'
      beforeId={Config.UI.before_layer}
      type='fill'
      layout={{ visibility: props.active ? "visible" : "none" }}          
      paint={{ 
        'fill-color': [
          'case',
          ['==', ['get', 'suitability'], 1], Config.suitability[1].color,
          ['==', ['get', 'suitability'], 2], Config.suitability[2].color,
          ['==', ['get', 'suitability'], 3], Config.suitability[3].color,
          ['==', ['get', 'suitability'], 4], Config.suitability[4].color,
          Config.suitability[0].color,
        ],
        'fill-opacity': [
          'case',
          ['boolean', ['feature-state', 'hover'], false],
          0.8,
          0.5
        ]
      }}
    />
    <Layer
      beforeId={Config.UI.before_layer}
      type='line'
      layout={{ visibility: props.active ? "visible" : "none" }}          
      paint={{
        "line-color": [
          'case',
          ['boolean', ['feature-state', 'hover'], false],
          'gold',
          'black'
          ],
        'line-width': [
          'case',
          ['boolean', ['feature-state', 'hover'], false],
          3,
          1
          ]
      }}
    />
  </LoadableSource>

export { HydrodynamicCentral } 
